<template>
  <div id="inicio">
    <v-container grid-list-lg fluid>
      <v-layout v-if="rol == 9 || rol == 7" row wrap>
        <v-flex xs12>
          <v-img :src="require('../assets/logo_cctp.svg')" class="my-3" contain height="400"></v-img>
        </v-flex>
      </v-layout>
      <v-layout v-else-if="rol == 10" row wrap>
      </v-layout>
      <v-layout v-else-if="rol == 8" row wrap>
        <v-flex xs12 sm8>
          <v-card>
            <v-card-text>
              <div id="fipe"></div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card>
            <v-card-title>
              <h4>Aperturas de subsede</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-list>
              <v-list-tile class="px-0">
                <v-list-tile-content>
                  <!-- <v-list-tile-title>Atendidas</v-list-tile-title> -->
                  <v-list-tile-sub-title>Pendientes</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon>
                    {{ dato.subsede.pendiente }}
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>Finalizadas</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon>
                    {{ dato.subsede.finalizado }}
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>Total</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon>
                    {{ dato.subsede.total }}
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- <v-layout v-else row wrap>
        <v-flex xs12>
          <v-img :src="require('../assets/logo_cctp.svg')" class="my-3" contain height="400"></v-img>
        </v-flex>
      </v-layout> -->
      <!-- <v-layout row wrap>
        <v-flex xs12 sm8>
          <div id="sfipe"></div>
        </v-flex>
      </v-layout> -->
      <v-snackbar
        v-model="snack.state"
        :top="'top'"
        :right="'right'"
        :color="snack.color"
        :multi-line="snack.mode === 'multi-line'"
        :timeout="2500"
        :vertical="snack.mode === 'vertical'"
        >
        {{ snack.text }}
        <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: "principal",
  data: () => ({
    // Tomar en cuenta los roles que estan directamente referenciados en template
    dialog: false,
    datos: [],
    params: {},
    rol: 0,
    dato: {
      apertura: {},
      ratificacion: {},
      ampliacion: {},
      razon_social: {},
      domicilio: {},
      derecho_propietario: {},
      cierre: {},
      subsede: {}
    },
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 2500,
      text: ""
    }
  }),
  mounted() {
    this.params = Service.getParams();
    if (this.params != null) {
      this.rol = this.params.roluser*1;
    }
    this.getCierreCursos(); //verifica si se cumplieron 72 horas desde el fin del curso, si se cumple se cierra el curso
    this.getDatos();
    
  },
  methods: {
    getCierreCursos() { // by neko
        this.loading = true;
        axios
          .get(Service.getBase() + 'lista/cierrecursos', Service.getHeader())
          .then(response => { 
            this.loading = false; 
            this.curof = response.data; console.log(this.curof);
          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });
    },

    getDatos() {
      axios
        // .get(Service.getBase() + "datos", Service.getHeader())
        // .get(Service.getBase() + "estadistica/solicitud", Service.getHeader())
        .get(Service.getBase() + "estadistica/tramite/tipo", Service.getHeader())
        .then(response => {
          this.dato = response.data;
          // this.solicitud = response.data.solicitud;
          if (this.rol == Service.rol().nacional) {
            Highcharts.chart("fipe", {
              chart: {
                type: "column"
              },
              title: { text: "Trámites pendientes y finalizados por tipo" },
              xAxis: {
                categories: ["Apertura", "Ratificación", "Ampliación", "Cambio de Razón Social", "Cambio de Domicilio", "Cambio de Derecho Propietario", "Cierre de CCTP's"]
              },
              yAxis: {
                min: 0,
                title: {
                  text: "Total trámites"
                },
                stackLabels: {
                  enabled: true,
                  style: {
                    fontWeight: "bold",
                    color:
                      // theme
                      (Highcharts.defaultOptions.title.style &&
                        Highcharts.defaultOptions.title.style.color) ||
                      "gray"
                  }
                }
              },
              legend: {
                align: "right",
                x: -30,
                verticalAlign: "top",
                y: 25,
                floating: true,
                backgroundColor:
                  Highcharts.defaultOptions.legend.backgroundColor || "white",
                borderColor: "#CCC",
                borderWidth: 1,
                shadow: false
              },
              tooltip: {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat:
                  "{series.name}: {point.y}<br/>Total: {point.stackTotal}"
              },
              plotOptions: {
                column: {
                  stacking: "normal",
                  dataLabels: {
                    enabled: true
                  }
                }
              },
              series: [
                {
                  name: "Pendientes",
                  data: [this.dato.apertura.pendiente*1, this.dato.ratificacion.pendiente*1, this.dato.ampliacion.pendiente*1, this.dato.razon_social.pendiente*1, this.dato.domicilio.pendiente*1, this.dato.derecho_propietario.pendiente*1, this.dato.cierre.pendiente*1],
                  color: "#ff9800"
                },
                {
                  name: "Finalizados",
                  data: [this.dato.apertura.finalizado*1, this.dato.ratificacion.finalizado*1, this.dato.ampliacion.finalizado*1, this.dato.razon_social.finalizado*1, this.dato.domicilio.finalizado*1, this.dato.derecho_propietario.finalizado*1, this.dato.cierre.finalizado*1],
                  color: "#009688"
                }
              ]
            });

            /* Highcharts.chart("solicitudes", {
              chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: "pie"
              },
              title: {
                text: "Solicitud de Apertura"
              },
              tooltip: {
                pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
              },
              accessibility: {
                point: {
                  valueSuffix: "%"
                }
              },
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: "pointer",
                  dataLabels: {
                    enabled: true,
                    format: "<b>{point.name}</b>: {point.percentage:.1f} %"
                  }
                }
              },
              series: [
                {
                  name: "Apertura",
                  colorByPoint: true,
                  data: [
                    {
                      name: "Atendidas",
                      y: 61.41,
                      sliced: true,
                      selected: true
                    },
                    {
                      name: "Pendientes",
                      y: 11.84
                    },
                    {
                      name: "Desestimado",
                      y: 10.85
                    }
                  ]
                }
              ]
            }); */
          }
        })
        .catch(error => {
          console.error("Error al cargar registros", error);
        });
    },

    showDialog() {
      this.mode = true;
      this.mdialog = true;
    },

    toast(mcolor, mtext) {
      this.snack.color = mcolor;
      this.snack.text = mtext;
      this.snack.state = true;
    },
    reportPDF() {
      // Obtencion de datos
      var myDataTable = [];
      myDataTable.push([
        {
          text: "Column 1",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#e0e3e5"
        },
        {
          text: "Column 2",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#e0e3e5"
        },
        {
          text: "Column 3",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#e0e3e5"
        },
        {
          text: "Column 4",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#e0e3e5"
        },
        {
          text: "Column 5",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#e0e3e5"
        }
      ]);
      // Definicion del documento PDF
      var docDefinition = {
        pageMargins: Service.pdfSetting().pMargin,
        pageSize: Service.pdfSetting().pSize,
        pageOrientation: Service.pdfSetting().pOrientation,
        defaultStyle: Service.pdfSetting().defStyle,
        header: Service.pdfSetting().myheaderV("REPORTE DE INFRAESTRUCTURA"),
        footer: Service.pdfSetting().myfooter,
        styles: Service.pdfSetting().mystyle,

        content: [
          {
            columns: [
              {
                //width: "16%",
                text: "Descripcion de la tabla ",
                fontSize: 10,
                bold: true
                //margin: [30, 1, 0, 2],
              }
            ]
          },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["40%", "22%", "13%", "12%", "13%"],
              body: myDataTable
            }
          }
        ]
      };
      // pdfMake.createPdf(docDefinition).open();
      pdfMake.createPdf(docDefinition).download("reportName.pdf");
    }
  }
};
</script>